import { parseSiteCluster } from './countReviewFlags.js';

/** Display cluster label: extras.cluster first, then site.cluster. */
export function getSiteClusterDisplay(site) {
  const { label } = parseSiteCluster(site);
  return label || '';
}
